import styles from './AnimatedBackground.module.css';

export default function AnimatedBackground() {
  return (
    <div className={styles.root} aria-hidden="true">
      <div className={styles.base} />
      <div className={styles.orbTeal} />
      <div className={styles.orbBlue} />
      <div className={styles.orbNavy} />
      <div className={styles.mesh} />
      <div className={styles.vignette} />
      <div className={styles.noise} />
    </div>
  );
}
